module.exports = __webpack_public_path__ + "static/media/ProfileIcon.bb4a143c.svg";